import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaClipboardList } from 'react-icons/fa';
import { CONTACT } from '../../utils/constants';

const EnquiryButton = ({ variant = 'default' }) => {
  // Google Form URL
  const googleFormUrl = CONTACT.googleFormLink || 'https://forms.google.com/your-form-id';

  // Minimal variant (keeps original logic just in case)
  if (variant === 'minimal') {
    return (
      <motion.a
        href={googleFormUrl}
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="inline-flex items-center gap-2 bg-accent-orange text-white px-6 py-3 rounded-button font-display font-bold shadow-card hover:bg-accent-orange/90 transition-all"
      >
        <FaClipboardList />
        <span>Submit Enquiry</span>
        <FaExternalLinkAlt className="text-sm" />
      </motion.a>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      // Changed: White background with Orange border for a cleaner look
      className="card bg-white border-2 border-accent-orange/20 shadow-xl p-8 text-center relative overflow-hidden rounded-3xl"
    >
      {/* Decorative background blob */}
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-32 h-32 bg-accent-yellow/20 rounded-full blur-2xl pointer-events-none"></div>

      {/* Main Icon with circular background */}
      <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm">
        <div className="text-5xl text-accent-orange drop-shadow-sm">📋</div>
      </div>

      <h3 className="text-3xl font-display font-bold mb-3 text-primary-green-dark">
        Submit an Enquiry
      </h3>
      
      <p className="text-neutral-gray-dark mb-8 text-lg leading-relaxed">
        Have a detailed question or request? Fill out our enquiry form and we'll get back to you.
      </p>

      {/* Button: Now carries the Gradient for high visibility */}
      <motion.a
        href={googleFormUrl}
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.05, boxShadow: "0 10px 25px -5px rgba(255, 152, 0, 0.4)" }}
        whileTap={{ scale: 0.95 }}
        className="inline-flex items-center gap-3 bg-gradient-to-r from-accent-orange to-accent-yellow text-white px-10 py-4 rounded-full font-display font-bold text-xl shadow-lg transition-all group"
      >
        <FaClipboardList className="text-2xl group-hover:rotate-12 transition-transform" />
        <span>Open Enquiry Form</span>
        <FaExternalLinkAlt className="text-base opacity-80" />
      </motion.a>

      <p className="text-sm text-neutral-gray-dark/60 mt-6 font-medium">
        Opens Google Form in a new tab
      </p>
    </motion.div>
  );
};

export default EnquiryButton;